import React from "react";
import { Col, Row } from "react-bootstrap";
import WordPress from "../../Assets/TechIcons/WordPress.svg";
import WooCommerce from "../../Assets/TechIcons/WooCommerce.svg";
import GeoDirectory from "../../Assets/TechIcons/GeoDirectory.svg";
import HTML5 from "../../Assets/TechIcons/HTML5.svg";
import CSS3 from "../../Assets/TechIcons/CSS3.svg";
import Reactjs from "../../Assets/TechIcons/React.svg";
import Next from "../../Assets/TechIcons/Next.svg";
import TailwindCSS from "../../Assets/TechIcons/Tailwind-CSS.svg";
import Vercel from "../../Assets/TechIcons/Vercel.svg";
import Elementor from "../../Assets/TechIcons/Elementor.svg";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={WordPress} alt="WordPress" className="tech-icon-images" />
        <div className="tech-icons-text">WordPress</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Elementor} alt="Elementor" className="tech-icon-images" />
        <div className="tech-icons-text">Elementor</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={WooCommerce} alt="WooCommerce" className="tech-icon-images" />
        <div className="tech-icons-text">WooCommerce</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={GeoDirectory} alt="GeoDirectory" className="tech-icon-images" />
        <div className="tech-icons-text">GeoDirectory</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={HTML5} alt="HTML5" className="tech-icon-images" />
        <div className="tech-icons-text">HTML5</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={CSS3} alt="CSS3" className="tech-icon-images" />
        <div className="tech-icons-text">CSS3</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Reactjs} alt="React" className="tech-icon-images" />
        <div className="tech-icons-text">React</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Next} alt="Next" className="tech-icon-images" />
        <div className="tech-icons-text">Next</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={TailwindCSS} alt="TailwindCSS" className="tech-icon-images" />
        <div className="tech-icons-text">TailwindCSS</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Vercel} alt="Vercel" className="tech-icon-images" />
        <div className="tech-icons-text">Vercel</div>
      </Col>

    </Row>
  );
}

export default Techstack;
